import { getErrorMessage } from '../../utils/errorMessage';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { getDeviceId } from '../../utils/deviceId';

const client = axios.create({ baseURL: API_BASE_URL, timeout: 10000 });
const publicClient = axios.create({ baseURL: API_BASE_URL, timeout: 10000 });
client.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['X-Xiaoying-Device-ID'] = getDeviceId();
  return config;
});

function unwrap(response) {
  const payload = response?.data;
  if (Number(payload?.code) === 401) {
    localStorage.removeItem('token');
    window.location.href = '/login';
  }
  if (!payload || Number(payload.code) !== 200) {
    const error = new Error(payload?.message || '团队服务暂不可用');
    error.code = payload?.data?.error_code || payload?.code;
    throw error;
  }
  return payload.data;
}

export async function getTeams() { return unwrap(await client.get('/team/list')); }
export async function getCurrentTeam() { return unwrap(await client.get('/team/current')); }
export async function switchTeam(id) { return unwrap(await client.post('/team/switch', { id })); }
export async function createTeam(name) { return unwrap(await client.post('/team/create', { name })); }
export async function updateTeam(id, name) { return unwrap(await client.post('/team/update', { id, name })); }
export async function getTeamMembers(id) { return unwrap(await client.get('/team/members', { params: { id } })); }
export async function inviteTeamMember(input) { return unwrap(await client.post('/team/invite', input)); }
export async function createTeamInvitationLink(input) { return unwrap(await client.post('/team/invitation-link/create', input)); }
export async function getLatestTeamInvitationLink(id) { return unwrap(await client.get('/team/invitation-link/latest', { params: { id } })); }
export async function getTeamInvitationLink(id) { return unwrap(await publicClient.get('/team/invitation-link/detail', { params: { id } })); }
export async function acceptTeamInvitationLink(id) { return unwrap(await client.post('/team/invitation-link/accept', { id })); }
export async function respondTeamInvitation(memberId, action) { return unwrap(await client.post('/team/invitation/respond', { member_id: memberId, action })); }
export async function updateTeamMember(input) { return unwrap(await client.post('/team/member/update', input)); }
export async function removeTeamMember(id, memberId) { return unwrap(await client.post('/team/member/remove', { id, member_id: memberId })); }
export async function leaveTeam(id) { return unwrap(await client.post('/team/leave', { id })); }
export async function deleteTeam(id) { return unwrap(await client.post('/team/delete', { id })); }
export async function uploadTeamLogo(id, file, target = 'logo') {
  const form = new FormData();
  form.append('id', id);
  form.append('file', file);
  form.append('target', target);
  return unwrap(await client.post('/team/branding/logo', form, { timeout: 30000 }));
}
export async function resetTeamLogo(id, target = 'logo') {
  return unwrap(await client.post('/team/branding/logo', { id, target, clear_logo: true }));
}

export async function getPublicTeamBrand(teamId) {
  return unwrap(await publicClient.get('/team/branding/public', { params: { team_id: teamId } }));
}

export function teamApiError(error, fallback) {
  return getErrorMessage(error, fallback);
}
